module.exports = __webpack_public_path__ + "img/alert-success.3f0a066a.svg";